<template>
  <section class="prospecting-section">
    <div class="triplea-container">
      <div class="prospecting-main-card">
        <div class="prospecting-main-card-image-bloc">
          <img src="@/assets/img/triplea/home/prospecting-section/prospecting-big-image.png"/>
        </div>
        <div class="prospecting-main-card-content-bloc">
          <div class="prospecting-main-content-texts-box">
            <h2>Apolar Triple A</h2>
            <p>Aqui, redefinimos o conceito de luxo. Para nós, luxo é sobre viver bem, com qualidade e atenção aos detalhes que realmente fazem a diferença. Nosso foco é conectar você ao imóvel que reflete suas aspirações e eleva seu dia a dia. Mais do que oferecer casas, proporcionamos experiências únicas, onde cada escolha, cada espaço, tem algo a mais.</p>
            <p>Seja bem-vindo!</p>
          </div>
          <div class="prospecting-main-card-content-cards-box">
            <div class="prospecting-main-card-content-card">
              <div class="prospecting-main-card-content-card-top">
                <img src="@/assets/img/triplea/home/prospecting-section/diversification.png"/>
              </div>
              <div class="prospecting-main-card-content-card-body">
                <h3>Diversificação</h3>
                <p>Mude para o extraordinário com imóveis que redefinem o conceito de luxo.</p>
              </div>
            </div>
            <div class="prospecting-main-card-content-card">
              <div class="prospecting-main-card-content-card-top">
                <img src="@/assets/img/triplea/home/prospecting-section/flexibility.png"/>
              </div>
              <div class="prospecting-main-card-content-card-body">
                <h3>Flexibilidade</h3>
                <p>Mude para o extraordinário com imóveis que redefinem o conceito de luxo. 
                  Sua oportunidade de viver com exclusividade está a um passo de distância!</p>
              </div>
            </div>
            <div class="prospecting-main-card-content-card">
              <div class="prospecting-main-card-content-card-top">
                <img src="@/assets/img/triplea/home/prospecting-section/profitability.png"/>
              </div>
              <div class="prospecting-main-card-content-card-body">
                <h3>Rentabilidade</h3>
                <p>Mude para o extraordinário com imóveis que redefinem o conceito de luxo. 
                  Sua oportunidade de viver com exclusividade está a um passo de distância!</p>
              </div>
            </div>
            <div class="prospecting-main-card-content-card">
              <div class="prospecting-main-card-content-card-top">
                <img src="@/assets/img/triplea/home/prospecting-section/appreciation.png"/>
              </div>
              <div class="prospecting-main-card-content-card-body">
                <h3>Valorização</h3>
                <p>Mude para o extraordinário com imóveis que redefinem o conceito de luxo. 
                  Sua oportunidade de viver com exclusividade está a um passo de distância!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import "@/assets/scss/custom/triplea/components/_home_prospecting_section.scss"
  export default {
    
  }
</script>


